import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import './Layout.scss';

const { Content } = Layout;

const AuthLayout = () => {
    return (
        <Layout className='layout'>
            <Content className='auth-layout-content'>
                <Outlet />
            </Content>
        </Layout>
    );
};

export default AuthLayout;
